export default __webpack_public_path__ + "50ffa3a3a272c269ffce15ecf36b3b82.png";